module.exports = __webpack_public_path__ + "static/media/guide_incorrect_2.add26dc8.png";